import { ClientApi } from '@quadminds/client-apis/base';
import { UNIT_TEST } from '@quadminds/shared/commons';
import { axiosResolver } from '@quadminds/shared/utils';
import { AxiosRequestConfig } from 'axios';
import { BASE_URL, CHAMELEON_PATH, DATA } from './constants';
import { Template } from './interfaces';
import { GetTiendaNubeCustomCarriersPayload, ImportTiendaNubePayload, GetDispositivosPayload } from './payloads';
import {
    DeleteTemplateResponse,
    GetTemplatesResponse,
    GetTiendaNubeCustomCarriersResponse,
    GetTiendaNubeTokenResponse,
    ImportTiendaNubeResponse,
    SaveTemplateResponse,
    GetDispositivosResponse,
} from './responses';
import { getStatus } from './utils';

export class ChameleonAjaxApi extends ClientApi {
    constructor() {
        super({
            baseURL: BASE_URL + CHAMELEON_PATH,
            withCredentials: false,
            ...(process.env[UNIT_TEST] && { adapter: 'http' }),
        });
    }

    public getTemplates() {
        const params = new URLSearchParams();
        params.append('data', DATA.GET_ORDER_TEMPLATES);

        return axiosResolver(() =>
            this.httpClient.post<GetTemplatesResponse>('', params, {
                ...this.getConfig(),
            }),
        );
    }

    public async saveTemplate(template: Template) {
        const params = new URLSearchParams();
        params.append('data', DATA.SAVE_ORDER_TEMPLATES);
        params.append('json_order_template', JSON.stringify(template));

        return axiosResolver(() =>
            this.httpClient.post<SaveTemplateResponse>('', params, {
                ...this.getConfig(),
            }),
        );
    }

    public async deleteTemplate(templateId: string) {
        const params = new URLSearchParams();
        params.append('data', DATA.DELETE_TEMPLATE);
        params.append('id_template', templateId);

        return axiosResolver(() =>
            this.httpClient.post<DeleteTemplateResponse>('', params, {
                ...this.getConfig(),
            }),
        );
    }

    public getTiendaNubeToken(userId: string) {
        const params = new URLSearchParams();
        params.append('data', DATA.GET_TIENDANUBE_TOKEN);
        params.append('id_usuario', userId);

        return axiosResolver(() =>
            this.httpClient.post<GetTiendaNubeTokenResponse>('', params, {
                ...this.getConfig(),
            }),
        );
    }

    public importTiendaNube({ dateFrom, dateTo, status, carriers }: ImportTiendaNubePayload) {
        const params = new URLSearchParams();
        params.append('data', DATA.IMPORT_TIENDANUBE);
        params.append('fecha_desde', dateFrom);
        params.append('fecha_hasta', dateTo);
        params.append('status', JSON.stringify(getStatus(status)));
        params.append('carriers', JSON.stringify(carriers));

        return axiosResolver(() =>
            this.httpClient.post<ImportTiendaNubeResponse>('', params, {
                ...this.getConfig(),
            }),
        );
    }

    public getTiendaNubeCustomCarriers({ dateFrom, dateTo, status, idUsuario }: GetTiendaNubeCustomCarriersPayload) {
        const params = new URLSearchParams();
        params.append('data', DATA.GET_TIENDANUBE_CUSTOM_CARRIERS);
        params.append('id_usuario', idUsuario);
        params.append('fecha_desde', dateFrom);
        params.append('fecha_hasta', dateTo);
        params.append('status', JSON.stringify(getStatus(status)));

        return axiosResolver(() =>
            this.httpClient.post<GetTiendaNubeCustomCarriersResponse>('', params, {
                ...this.getConfig(),
            }),
        );
    }

    public getDevices({ idUsuario }: GetDispositivosPayload) {
        const params = new URLSearchParams();
        params.append('data', DATA.GET_DISPOSITIVOS);
        params.append('id_usuario', idUsuario);

        return axiosResolver(() =>
            this.httpClient.post<GetDispositivosResponse>('', params, {
                ...this.getConfig(),
            }),
        );
    }

    private getConfig(): AxiosRequestConfig {
        return {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            responseType: 'json',
        };
    }
}
